import { notAnyValueCheck } from '@/ag-grid/utils/notAnyValue'
import { getProp } from '@lib/generic.utils'
import { agDepartmentsCol } from '@/ag-grid/ag-columns'
import store from '@/store'

export const subscriptionsCol = () => ({
  headerName: 'SUBSCRIPTIONS',
  field: 'name',
  type: ['textFilterColumn']
})

export const productTypeCol = () => ({
  headerName: 'Product Type',
  field: 'product_type',
  type: ['textFilterColumn']
})

export const publisherCol = () => ({
  headerName: 'Publisher',
  field: 'publisher',
  type: ['textFilterColumn']
})

export const vendorCol = () => ({
  headerName: 'Vendor',
  field: 'vendor',
  type: ['textFilterColumn']
})

export const cancellationDeadlineCol = () => ({
  headerName: 'Decision Deadline',
  field: 'cancellation_deadline',
  hide: true
})

export const publisherReferenceCol = () => ({
  headerName: 'Publisher Reference',
  type: ['textFilterColumn'],
  field: 'publisher_reference',
  hide: true,
  cellRenderer: notAnyValueCheck
})

export const libraryReferenceCol = () => ({
  headerName: 'Library Reference',
  field: 'library_reference',
  type: ['textFilterColumn'],
  hide: true,
  cellRenderer: notAnyValueCheck
})

export const licenseManagerCol = () => ({
  headerName: 'License Manager',
  field: 'owner',
  type: ['textFilterColumn']
})

export const stakeholdersCol = () => ({
  headerName: 'Stakeholders',
  field: 'stakeholders',
  type: ['textFilterColumn'],
  hide: true
})

export const financialPeriod = () => ({
  headerName: 'Financial Period',
  field: 'financial_period',
  type: ['textFilterColumn'],
  cellRenderer: params => getProp(params?.data?.financial_period, 'abbreviation'),
  tooltipValueGetter: params => getProp(params?.data?.financial_period, 'abbreviation'),
  hide: true
})

export const costCentersCol = () =>
  agDepartmentsCol(
    'lv-subscriptions',
    {
      headerName: store.getters['entity-labels/costCenterLabel'].singular,
      field: 'cost_centers',
      hide: true
    },
    {
      optionsModule: 'lv-subscriptions',
      optionsState: 'costCenters'
    }
  )
